import React, { useEffect, useState } from 'react'
import { colors, Grid, H1, LayoutBand, useContainerWidth } from '@fs/zion-ui'
import { css } from '@emotion/core'
import { useHistory } from '@fs/zion-router'
import getPermission from '@fs/zion-permissions'
import dirtAndGold from '../resources/dirt-and-gold.webp'
import { PORTAL_CONTEXT, TOOLS_PERMISSION } from '../constants'

const styleCss = css`
  background: linear-gradient(to right, ${colors.gray00}, ${colors.yellow03});
`
const backdropCss = css`
  backdrop-filter: blur(10px);
`

export default function UnauthorizedPage() {
  const atWidth = useContainerWidth()
  const history = useHistory()

  const [authorized, setAuthorized] = useState(undefined)

  async function getPerm() {
    const response = await getPermission(TOOLS_PERMISSION, PORTAL_CONTEXT)
    setAuthorized(response.authorized)
    if (response.authorized) {
      history.push('/')
    }
  }

  useEffect(() => {
    getPerm().catch(console.error)
  })

  return (
    <div css={styleCss}>
      <LayoutBand
        marginY="md"
        alignY="middle"
        image={dirtAndGold}
        minHeight={600}
        css={atWidth({ default: backdropCss, lg: null })}
      >
        {authorized !== undefined && (
          <Grid>
            <div columns={atWidth({ default: 12, lg: 6 })} css={atWidth({ default: backdropCss, lg: null })}>
              <H1 size="H3">Unauthorized</H1>
            </div>
          </Grid>
        )}
      </LayoutBand>
    </div>
  )
}
